import { render, staticRenderFns } from "./index(old).vue?vue&type=template&id=48ba752e&"
import script from "./index(old).vue?vue&type=script&lang=js&"
export * from "./index(old).vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports